module.exports = __webpack_public_path__ + "media/feedback/feedback_featured-e2e5e93e.png";